'use client'

import { BottomCTA, Text } from '@macarongfactory/web-ui'

import { logEvent } from '@/shared/external/firebase/analytics'
import { useSeoOnelinkUrl } from '@/shared/external/onelink'
import { CODE, EVENT_NAMES, TYPE } from '@/shared/lib'
import { cn } from '@/shared/lib/cn'

import {
  closeCurrentTab,
  PLACE_DETAIL_APP_DOWNLOAD_ONELINK_URL,
  PLACE_DETAIL_PARTNER_CTA_TEXT,
} from '../../lib'

const COUPON_DESCRIPTION = '20,000원 할인 쿠폰 지급중'
const CTA_BUTTON_TEXT = '쿠폰받고 앱으로 예약하기'

interface IPlaceMobileCtaProps {
  isPartnerEntry?: boolean
}

const PlaceMobileCta = ({ isPartnerEntry }: IPlaceMobileCtaProps) => {
  const onelinkUrl = useSeoOnelinkUrl(PLACE_DETAIL_APP_DOWNLOAD_ONELINK_URL)
  const ctaButtonText = isPartnerEntry
    ? PLACE_DETAIL_PARTNER_CTA_TEXT
    : CTA_BUTTON_TEXT

  // 디자인 어노테이션: CTA 클릭 시 뜨던 모달 삭제 → 원링크로 바로 이동
  // 제휴 유입은 앱 설치 대신 탭을 닫고 예약 화면으로 돌아간다 (WEB-5901)
  const handleCtaClick = () => {
    logEvent(EVENT_NAMES.COMMON_WEB_PLACE.ITEM.CLICK, {
      code: CODE.COMMON_WEB_PLACE.CTA,
      type: TYPE.BUTTON,
      label: ctaButtonText,
    })
    if (isPartnerEntry) {
      closeCurrentTab()
      return
    }
    window.location.href = onelinkUrl
  }

  return (
    // bottomPadding을 사용하면 web-ui가 가짜 홈 인디케이터(검은 알약)를 그리므로 사용하지 않는다.
    // wrapper에 배경을 깔면 BottomCTA 상단 그라데이션이 가려지므로 투명으로 두고,
    // safe-area 영역만 별도 흰 div로 채워 OS 홈바 영역 색을 맞춘다.
    // 제휴 유입은 PC 사이드 스티키 카드 대신 이 하단 고정 CTA를 그대로 쓴다 (WEB-5901)
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 mx-auto max-w-[480px]',
        !isPartnerEntry && 'lg:hidden'
      )}
    >
      <BottomCTA.Vertical
        position='relative'
        top={
          isPartnerEntry ? undefined : (
            <Text
              variant='title-2-medium'
              color='text-foreground-neutral-alternative'
              className='text-center'
            >
              {COUPON_DESCRIPTION}
            </Text>
          )
        }
        mainButton={
          <BottomCTA.MainButton.SolidButton
            text={ctaButtonText}
            onClick={handleCtaClick}
          />
        }
      />
      <div
        className='bg-background-surface-default'
        style={{ height: 'env(safe-area-inset-bottom)' }}
      />
    </div>
  )
}

export default PlaceMobileCta
